import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { NoIconIcon, BankIcon, CausesIcon, MerchantIcon, UserProfileIcon, BillPaymentIcon, RecurrentIcon } from '@paypalcorp/pp-react-icons';
import { cx } from '@paypalcorp/pp-react-utils';
import { Shimmer } from '@paypalcorp/pp-react-shimmer';
import * as styles from './styles.css';
export { styles as avatarStyles };

var _excluded = ["className", "color", "size", "src", "alt", "initials", "loading", "svgIconComponent", "badge", "generic", "isLoading", "isInverse", "children"];
var getIconSize = function (size) {
  switch (size) {
    case 'lg':
      return 'md';
    case 'md':
      return 'sm';
    case 'sm':
      return 'xs';
    case 'xs':
      return 'xs';
  }
};
var Avatar = function (_ref) {
  var className = _ref.className,
    color = _ref.color,
    size = _ref.size,
    src = _ref.src,
    alt = _ref.alt,
    initials = _ref.initials,
    loading = _ref.loading,
    svgIconComponent = _ref.svgIconComponent,
    badge = _ref.badge,
    generic = _ref.generic,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Default to 'lg' if size is not valid
  var validSize = ['lg', 'md', 'sm', 'xs'].includes(size) ? size : 'lg';
  var sizeMap = {
    md: styles.sizeMd,
    sm: styles.sizeSm,
    xs: styles.sizeXs,
    lg: styles.sizeLg
  };
  if (isLoading) {
    var shimmerClasses = cx(styles.shimmer, sizeMap[validSize], className);
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: shimmerClasses,
      isInverse: isInverse,
      hasStyleDefaults: false
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var genericMap = {
    default: '',
    profile: styles.profile,
    merchant: styles.merchant,
    causes: styles.causes,
    bank: styles.bank,
    biller: styles.biller,
    subscription: styles.subscription
  };
  var computedColor = function getColor(colour) {
    if (generic || src) return null;else if (initials) {
      var sum = initials.charCodeAt(0) + (initials[1] ? initials === null || initials === void 0 ? void 0 : initials.charCodeAt(1) : 0);
      // istanbul ignore next
      var allowedColors = ['accent1', 'accent2', 'accent3', 'accent4'];
      var acceptedColors = Object.keys(allowedColors);
      var index = sum % acceptedColors.length;
      return allowedColors[index];
    } else if (colour) {
      return colour;
    }
    return null;
  }(color);
  var avatarClasses = cx(styles.base, sizeMap[validSize],
  //@ts-ignore
  computedColor && styles.acceptedColorClasses[computedColor], ['default', 'profile', 'merchant', 'causes', 'bank', 'subscription', 'biller'].includes(generic) && genericMap[generic], className);
  var avatarBadge = badge && validSize !== 'xs' && validSize !== 'sm' ? React.cloneElement(badge, {
    className: styles.avatarBadge
  }) : null;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: avatarClasses,
    "data-ppui-info": "avatar_5.2.3__8.12.2-beta.0"
  }, rest), function avatarContent() {
    if (src) {
      return /*#__PURE__*/React.createElement("img", {
        className: styles.image,
        src: src,
        alt: alt,
        loading: loading,
        "data-ppui": "true"
      });
    }
    if (svgIconComponent) {
      return /*#__PURE__*/React.createElement(svgIconComponent, {
        size: getIconSize(validSize),
        "data-ppui": "true"
      });
    }
    if (generic) {
      var _genericIconMap$gener;
      var genericIconMap = {
        default: NoIconIcon,
        bank: BankIcon,
        causes: CausesIcon,
        merchant: MerchantIcon,
        profile: UserProfileIcon,
        biller: BillPaymentIcon,
        subscription: RecurrentIcon
      };
      var GenericIcon = (_genericIconMap$gener = genericIconMap[generic]) !== null && _genericIconMap$gener !== void 0 ? _genericIconMap$gener : genericIconMap.default;
      /* istanbul ignore next */
      if (GenericIcon) {
        return /*#__PURE__*/React.createElement(GenericIcon, {
          name: generic,
          size: getIconSize(validSize),
          "data-ppui": "true"
        });
      }
    }
    return validSize === 'xs' ? initials[0] : initials;
  }(), avatarBadge);
};

export { Avatar };
